import React from 'react';
import { connect } from 'react-redux';
import { userActions, permissionActions, inventoryActions } from '../_actions';
import { authHeader, config } from '../_helpers';
import Modal from 'react-responsive-modal';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { AlertPopup } from '../_components/AlertPopup';
import NumberFormat from 'react-number-format';
import { getCompanyName, unAvailableReason } from '../_utils/utils';
import ChangeStatusModal from '_components/ChangeStatusModal';
import ApplicationHistoryAlert from '_components/ApplicantHistoryAlert';
import ViewExpiryAndAssignedDates from '_components/ViewExpiryAndAssignedDates';
import ViewProfile from '_components/Profile/ViewProfile';

function formatPhoneNumber(s) {
  var s2 = ('' + s).replace(/\D/g, '');
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hash: this.props.hash.split('/')[2],
      statusOpen: false,
      mailSendOpen: false,
      email: true,
      sms: true,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      message: '',
      notes: '',
      alertPop: false,
      userName: '',
      isGuest: false,
      unavailableReason: 0,
      otherReason: '',
    };
    this.goBack = this.goBack.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  handleChange(event) {
    if (event.target.name === 'notes') {
      if (this.state.permList.includes('Employee Notes')) {
        this.setState({
          [event.target.name]: event.target.value,
          template: 'custommail',
        });
      }
      return;
    }
    this.setState({
      [event.target.name]: event.target.value,
      template: 'custommail',
    });
  }

  handleCheck(event) {
    // var value = event.target.name === 'email' ? this.state.email : this.state.sms;
    // this.setState({ [event.target.name]: !value });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  componentDidMount() {
    var hash = '?hash=' + this.state.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(permissionActions.getPermission());
    let data = new FormData();
    data.append('hash', this.state.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
  }

  componentWillReceiveProps(nextProps) {
    const { user, inventory, permission } = nextProps;
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;

      this.setState({
        permList,
      });
    }
    var generalQualificationList = [],
      inventory_list = [];
    if (inventory.inventory) {
      if (inventory.inventory.data) {
        var total_cost = 0;
        inventory.inventory.data.map((item, index) => {
          total_cost += parseInt(item.cost);
          inventory_list.push(
            <div className="inv_item">
              <div className="inv_cell">
                {index + 1 + '. ' + item.unique_id + ' (' + item.type + ') '}
                {/*<span className="cost">{"$"+item.cost}</span>*/}
                <NumberFormat
                  className="cost"
                  value={item.cost}
                  displayType={'text'}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              </div>
              {/*<div className="inv_cell" data-header-title="Unique Id">{item.unique_id}</div>
                            <div className="inv_cell" data-header-title="Cost">{item.cost}</div>*/}
            </div>
          );
          return inventory_list;
        });
        this.setState({ inventory_list, total_cost });
      }
    }
    if (user.items) {
      this.setState({ active: user.items.data.active });
      var profile = user.items.data;
      var available = profile.active === 'Available' ? true : false;
      this.setState({
        status: profile.active,
        available: available,
        notes: this?.state?.notes ? this?.state?.notes : profile.notes,
        profile,
        hash: profile.hash,
        userName: profile.first_name,
        user_type: user.items.data.user_type,
        isGuest: user.items.data.status === 3 ? true : false,
        unavailableReason: profile.unavailable_reason,
        otherReason: profile.other_reason,
      });
      if (profile.qualification) {
        profile.qualification.map((item, index) => {
          generalQualificationList.push(
            <p className="crew-profile-detail" key={index}>
              {item}
            </p>
          );
          return generalQualificationList;
        });
      }
    }

    if (user.profile) {
      this.setState({
        active: user.profile.data.active,
      });
    }

    this.setState({
      generalQualificationList,
    });
    if (user.notes) {
      if (user.notes.success) {
      } else {
        // alert(user.notes.message);
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.notes.message,
          alertFunction: '',
        });
      }
      this.props.dispatch(userActions.getProfile(hash));
    }
  }

  setStatusReturn(status) {
    if (status) {
      var step = '2a';
    } else step = '2b';
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  updateNotes(hash) {
    let data = new FormData();
    data.append('hash', hash);
    data.append('note', this.state.notes);
    if (this.state.notes !== null) {
      this.setState({ savingNote: true });
      this.props
        .dispatch(userActions.updateEmployeeNote(data, '?hash=' + hash))
        .then(
          (res) => {
            toast.success('Notes Saved !');
            this.setState({ savingNote: false });
          },
          (err) => {
            toast.error('Notes Cannot be saved');
            this.setState({ savingNote: false });
          }
        );
    }
    // this.props.dispatch(userActions.getProfile("?hash="+hash));
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status) {
    if (status) {
      var stat =
        this.state.status === 'Available' ? 'Unavailable' : 'Available';
      var hash = '?hash=' + this.state.hash;
      let data = new FormData();
      this.statusCloseModal();
      data.append('end_date', this.state.returnDate);
      data.append('hash', this.state.hash);
      data.append('status', stat);
      this.props.dispatch(userActions.changeStatus(data, hash)).then(
        (res) => toast.success('Notes Saved !'),
        (err) => toast.error('Notes Cannot be saved')
      );
      this.setState({ status: stat });
    }
  }

  remove(hash) {
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', hash);
    this.props.dispatch(userActions.removeEmployee(data));
    // this.props.goBack(this.props.resourceDetails);
  }

  goBack() {
    this.props.goBack(this.props.resourceDetails);
  }

  editProfile(hash) {
    this.props.editProfile(hash);
  }

  print() {
    window.print();
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    var self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        // alert( JSON.stringify( data.message ) )
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  setUnAvailableReason = (reason, other) => {
    return unAvailableReason(reason, other);
  };

  render() {
    const { user, permission } = this.props;
    if (user.items) {
      var profile = user.items.data;
    }
    var permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    if (this.state.profile) {
      return (
        // details

        <div className="resource_container profile_container">
          <div className="breadcrumbs">
            <span className="green" onClick={this.goBack.bind(this)}>
              Your Crew
            </span>{' '}
            / Profile
          </div>
          <div className="page_title float">
            <h1>
              {this.state.profile
                ? this.state.profile.first_name +
                  ' ' +
                  this.state.profile.last_name
                : ''}
            </h1>
          </div>
          <ViewProfile
            userHash={this.props?.user?.items?.data?.hash}
            authUser={this.props?.user?.profile?.data?.hash}
            permList={permList}
            changeTab={this.changeTab}
          />
          {this.state.statusOpen ? (
            <ChangeStatusModal
              open={this.state.statusOpen}
              onClose={this.statusCloseModal}
            />
          ) : null}

          <Modal
            style={'width: 200px'}
            id="email_popup"
            className="status_popup"
            open={this.state.mailSendOpen}
            onClose={this.mailSendCloseModal.bind(this)}
            little
          >
            <div id="emailPopup">
              <div className="modal-head">
                <h4 className="modal-title">Custom Message</h4>
              </div>
              <div className="modal-body">
                {/* <p><input type="checkbox" name="email" defaultValue="true" onChange={this.handleCheck.bind(this)}>Email</input></p> */}
                {/* <p><input type="checkbox" name="sms" defaultValue="true" onChange={this.handleCheck.bind(this)}>SMS</input></p> */}
                <textarea
                  name="message"
                  cols="80"
                  rows="10"
                  value={this.state.message}
                  onChange={this.handleChange.bind(this)}
                />

                <p className="step_no">
                  Signature will automatically be included.
                </p>
                {/*<div className="btn_list">*/}
                <button
                  className="button grey"
                  onClick={this.mailSendCloseModal.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className="button"
                  onClick={this.sendMail.bind(this, this.state.hash)}
                >
                  Send
                </button>
                {/*</div>*/}
              </div>
            </div>
          </Modal>
          {this.state.alertPop && (
            <AlertPopup
              head={this.state.alertHead}
              message={this.state.alertMsg}
              alertFunction={this.state.alertFunction}
              close={this.closeAlert.bind(this)}
            />
          )}
        </div>
      );
    } else {
      return <></>;
    }
  }
}

function mapStateToProps(state) {
  const { user, permission, inventory } = state;
  return {
    user,
    permission,
    inventory,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(Profile);
export { connectedRegisterPage as Profile };
